






























import { Component, Model, Vue } from "vue-property-decorator";
//import { mapState } from "vuex";
import { FileFilter } from "@/store/modules/types";

@Component({
    //computed: mapState("gaps", ["insurers"])
})
export default class FileSearch extends Vue {
    @Model("change") readonly filter!: FileFilter;
}
